import Vue from 'vue';
import axios from "axios";
Vue.use(axios);

function iconName(map_data , no) {
  if (map_data.icons[no]) {
    return map_data.icons[no].name;
  }
  return no;
}

function iconCategory(map_data, no) {
  if (map_data.icons[no]) {
    var category_id = map_data.icons[no].category;

    return map_data.category[category_id].id;
  }
  return no;
}


export default async function  generateMapCSV(parent_id , map_data)  {
  
  let output = []
  // let result = Object.assign({}, this.map_data.markers);
  let result = JSON.parse(JSON.stringify(map_data.markers));

  
  for (let img_no in result) {
      const data = result[img_no];
      data.forEach((element) => {
        // console.log(element)

        let item = {}
        item.map_id = parent_id
        item.sub_map_id = element.sub_map_id || ""
        item.id = element.id
        item.category = iconCategory(map_data,element.img_no)
        item.img_no = element.img_no
        item.アイコン = iconName(map_data,element.img_no)
        item.lat = element.lat
        item.lng = element.lng
        item.label = element.label || ""

        // カンマが含まれている場合、ダブルクオーテーションで囲む
        if (typeof element.search_group === 'string' && (element.search_group.includes(',') || element.search_group.includes('"'))) {
          element.search_group = `"${element.search_group.replace(/"/g, '""')}"`; // ダブルクオーテーション内のダブルクオーテーションもエスケープ
        }

        item.search_group = element.search_group || ""
        item.content = element.content || ""

        if(map_data.icons[element.img_no]){
          output.push(item)
        }
      });
  }


  // let outputData = this.map_data.markers.map((item) => {
  //   // プロパティの順序を明示的に指定して新しいオブジェクトを作成
  //   const newItem = {
  //     date: item.date, // まずnameを追加
  //     pv: item.pv, // 次にidを追加
  //     session: item.session, // 次にidを追加
  //     user: item.user, // 次にidを追加
  //   };

  //   return newItem;
  // });

  // console.log("outputData",output);
  return output;

  // // // バイナリ形式で作成
  // const blob = new Blob([this.convertObjectToCSV(output)], {
  //   type: "text/csv",
  // });
  // const url = (window.URL || window.webkitURL).createObjectURL(blob);
  // const a = document.createElement("a");
  // a.href = url;

  // let file_name = "";
  // if(!this.id){
  //   file_name = this.parent_id+"_all_"+this.map_name + ".csv";
  // }else{
  //   file_name = this.parent_id+"_"+this.id+"_"+this.map_name + ".csv";
  // }

  // a.download = file_name;
  // document.body.appendChild(a);
  // a.click();

}
